<template lang="pug">
.summary-container
  //- STEPPERS ARRIBA DE TODO CON LÍNEA CONECTORA
  .stepper-wrapper-main
    .stepper-items-container
      .stepper-item-main
        .stepper-circle.completed
          v-icon(color="white" size="20") check
        span.stepper-label Solicitud
      .stepper-line-connector
      .stepper-item-main
        .stepper-circle.completed
          v-icon(color="white" size="20") check
        span.stepper-label.active Resumen
  
  //- RESUMEN
  v-layout#ly_resumen_anulacion
    v-flex(xs12 sm12 md12 lg12)
      h2.omnesMedium.text-xs-center.text-md-center.title-solicitud
        | Resumen de tu solicitud
      
      v-layout.detalle-actual
        v-flex(xs12 sm12 md12 lg12)
          v-layout
            v-flex(xs5 sm6 md7 lg7)
              p.label-resumen Número de póliza:
            v-flex(xs7 sm6 md5 lg5)
              p.text-resumen {{ policy }}
      
      div.detalle-cambio
        v-flex(xs12 sm12 md12 lg12)
          v-layout
            v-flex(xs5 sm6 md7 lg7)
              p.label-resumen Producto:
            v-flex(xs7 sm6 md5 lg5)
              p.text-resumen {{ product }}
          v-layout
            v-flex(xs5 sm6 md7 lg7)
              p.label-resumen N° documento del titular:
            v-flex(xs7 sm6 md5 lg5)
              p.text-resumen {{ numberDocument }}
          v-layout
            v-flex(xs5 sm6 md7 lg7)
              p.label-resumen Tipo de solicitud:
            v-flex(xs7 sm6 md5 lg5)
              p.text-resumen Anulación de póliza
          v-layout(v-if="cancellationReason")
            v-flex(xs5 sm6 md7 lg7)
              p.label-resumen Motivo de anulación:
            v-flex(xs7 sm6 md5 lg5)
              p.text-resumen {{ cancellationReason }}
      
      v-layout
        v-flex.btns-actions(xs12 sm12 md12 lg12)
          v-btn#btnSendSolicitud.omnesSemibold(
            type='button' 
            :disabled="isDisabled || loader" 
            @click="$emit('confirm')"
          ) Confirmar
          a.omnesMedium#btnBack(href="#" @click.prevent="$emit('go-back')") Volver
</template>

<script>
/**
 * @component StepSOATCancellationSummary
 * @description Paso de resumen de solicitud de anulación de póliza SOAT.
 * Muestra todos los datos antes de confirmar el envío.
 * 
 * @example
 * <StepSOATCancellationSummary
 *   policy="123456789"
 *   product="SOAT"
 *   number-document="12345678"
 *   cancellation-reason="Ya no tengo el vehículo"
 *   :is-disabled="false"
 *   :loader="isLoading"
 *   @confirm="handleConfirm"
 *   @go-back="handleGoBack"
 * />
 */
export default {
  name: 'StepSOATCancellationSummary',
  props: {
    policy: {
      type: String,
      required: true
    },
    product: {
      type: String,
      required: true
    },
    numberDocument: {
      type: String,
      required: true
    },
    cancellationReason: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.summary-container {
  width: 100%;
}

.stepper-wrapper-main {
  width: 100%;
  padding: 40px 0;
  margin-bottom: 20px;
}

.stepper-items-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 0;
  position: relative;
}

.stepper-line-connector {
  width: 80px;
  height: 2px;
  background: #0855C4;
  position: relative;
  top: 19px;
  margin: 0 10px;
}

.stepper-item-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.stepper-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #0855C4;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stepper-circle.completed {
  background: #0855C4;
}

.stepper-label {
  font-size: 12px;
  color: #666;
  font-family: 'Omnes Regular';
}

.stepper-label.active {
  color: #0855C4;
  font-weight: 600;
  font-family: 'Omnes SemiBold';
}

#ly_resumen_anulacion {
  background: #FFF;
  padding: 24px 20px;
  border-radius: 8px;
  border: 1px solid #DADADA;
}

#ly_resumen_anulacion h2 {
  padding: 0 0 16px 0;
  font-size: 18px;
  color: #0855C4;
}

#ly_resumen_anulacion .detalle-actual {
  margin-top: 16px;
  margin-left: -20px;
  margin-right: -20px;
  padding: 12px 20px;
  border-top: 2px dashed #DADADA;
  border-bottom: 2px dashed #DADADA;
  background-color: #FFF;
}

#ly_resumen_anulacion .detalle-cambio {
  margin-top: 0;
  margin-left: -20px;
  margin-right: -20px;
  padding: 16px 20px;
  border-top: none;
  border-bottom: 2px dashed #DADADA;
  background-color: #F9F9F9;
}

#ly_resumen_anulacion .detalle-actual .v-layout,
#ly_resumen_anulacion .detalle-cambio .v-layout {
  margin-bottom: 10px;
}

#ly_resumen_anulacion .detalle-actual .v-layout:last-child,
#ly_resumen_anulacion .detalle-cambio .v-layout:last-child {
  margin-bottom: 0;
}

#ly_resumen_anulacion p.label-resumen {
  font-family: 'Omnes Regular';
  color: #454A6C;
  margin: 0;
  font-size: 13px;
  text-align: left;
}

#ly_resumen_anulacion p.text-resumen {
  font-family: 'Omnes Medium';
  font-size: 13px;
  color: #454A6C;
  font-weight: 600;
  margin: 0;
  text-align: right;
}

#ly_resumen_anulacion .btns-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  padding: 0 20px;
}

#ly_resumen_anulacion #btnBack {
  margin: 12px 0 0 0 !important;
  padding: 0;
  font-size: 14px;
  color: #0855C4;
  text-decoration: none;
  font-family: 'Omnes Medium';
}

#ly_resumen_anulacion #btnBack:hover {
  text-decoration: underline;
}

#btnSendSolicitud {
  background: #EA0D90 !important;
  color: #FFF !important;
  padding: 0 !important;
  border-radius: 4px;
  text-transform: none;
  font-size: 15px;
  box-shadow: none !important;
  width: 272px !important;
  height: 56px !important;
  min-width: 272px !important;
  max-width: 272px !important;
}

#btnSendSolicitud:hover {
  background: #D10C80 !important;
}

#btnSendSolicitud:disabled {
  background: #E0E0E0 !important;
  color: #999 !important;
}

.title-solicitud {
  color: var(--second-brand-color);
  font-weight: initial;
  font-family: 'Omnes Regular';
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/soat/StepSOATCancellationSummary.vue